import { FilterType, FilterVM } from '../common/view-model';

export const showParticipationFiltersMock: FilterVM[] = [
	{
		id: 'expo-west-26',
		name: "Expo West '26",
		isChecked: false,
		children: [],
		type: FilterType.SHOW_PARTICIPATION
	},
	{
		id: 'newtopia-26',
		name: "Newtopia Now '26",
		isChecked: false,
		children: [],
		type: FilterType.SHOW_PARTICIPATION
	}
];
